export enum ECreatorMediaTypes {
  Video = 'video',
  Audio = 'audio',
  Text = 'text',
  Image = 'image'
}

export enum ECreatorVideoTypes {
  Fullscreen = 'fullscreen',
  Preview = 'preview'
}
